// extracted by mini-css-extract-plugin
export var borderRadius = "_9y-4";
export var large = "_9y-3";
export var logoContainer = "_9y-0";
export var nameLogo = "_9y-2";
export var small = "_9y-1";